import React, { FC } from 'react';
import { RelatedProductCardTitleProps } from './model';

const RelatedProductCardTitle: FC<RelatedProductCardTitleProps> = ({ title }) => {
  return <div className="related-product-card__title">{title}</div>;
};

export default RelatedProductCardTitle;
